// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2RdCn"};